import React from 'react';

const VytalCountContext = React.createContext();

export default VytalCountContext;
